"use client";

import { motion } from "framer-motion";

import { crossfadeVariants } from "@/lib/animations";

export function DashboardSkeleton() {
  return (
    <motion.div
      initial="hidden"
      animate="visible"
      exit="exit"
      variants={crossfadeVariants}
      className="mx-auto w-full max-w-wide-content space-y-8 px-3 py-4 md:py-8"
    >
      {/* Today section skeleton */}
      <div className="space-y-3">
        <div className="h-5 w-28 animate-pulse rounded bg-muted" />
        <div className="grid grid-cols-2 gap-3 @md:grid-cols-3">
          {Array.from({ length: 3 }, (_, i) => (
            <div key={i} className="animate-pulse rounded-xl bg-muted aspect-[4/3]" />
          ))}
        </div>
      </div>

      {/* Coming up section skeleton */}
      <div className="space-y-3">
        <div className="h-5 w-36 animate-pulse rounded bg-muted" />
        <div className="space-y-2">
          {Array.from({ length: 4 }, (_, i) => (
            <div key={i} className="flex items-center gap-3">
              <div className="h-4 w-16 animate-pulse rounded bg-muted" />
              <div className="h-12 flex-1 animate-pulse rounded-lg bg-muted" />
            </div>
          ))}
        </div>
      </div>

      {/* Bottom sections skeleton */}
      <div className="flex flex-col gap-8 @md:flex-row @md:items-start">
        <div className="flex-1 space-y-3">
          <div className="h-5 w-32 animate-pulse rounded bg-muted" />
          <div className="h-24 animate-pulse rounded-xl bg-muted" />
        </div>
        <div className="min-w-0 flex-1 space-y-3">
          <div className="h-5 w-28 animate-pulse rounded bg-muted" />
          <div className="h-24 animate-pulse rounded-xl bg-muted" />
        </div>
      </div>
    </motion.div>
  );
}
